import LockIcon from '@mui/icons-material/Lock';
import { Box, Typography } from '@mui/material';

interface CollapsedClusterFooterProps {
  childCount: number;
  isLocked?: boolean;
  ownerName?: string;
}

export function CollapsedClusterFooter({
  childCount,
  isLocked = false,
  ownerName = '',
}: CollapsedClusterFooterProps) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: 'rgba(255, 255, 255, 0.7)',
        borderTop: '1px solid #f3f5f8',
        display: 'flex',
        fontSize: 12,
        justifyContent: 'flex-end',
        px: 0.75,
        py: 0.5,
        gap: 0.5,
      }}
    >
      {isLocked && <LockIcon fontSize="inherit" />}
      {ownerName && (
        <Typography variant="caption" sx={{ fontSize: 10 }}>
          {ownerName}
        </Typography>
      )}
      <Typography variant="caption" sx={{ fontSize: 10 }}>
        {childCount}
      </Typography>
      <Box component="img" src="https://storage.googleapis.com/dotstorming-img/walls/cards.png" />
    </Box>
  );
}
